<div>
    <h2 class="mat-title">
        Designees Editor
    </h2>
    <div>
        <div *ngIf="Designees">There are currently {{Designees.length}} designees in the DELTA system. Please use the panel below to add new designees to the system, and use the tools in the designees table below to remove designees from the DELTA system.</div>
        <div class="buttongroup smalldisplaybuttongroup" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start center" fxLayoutGap.lt-md="10px">
            <button mat-raised-button color="accent" (click)="DownloadDesigneesPDF()">Download Designees PDF</button>
        </div>
    </div>

    <!-- New User Form -->
    <div class="mat-elevation-z12 padding">
        <h2 class="mat-headline">New Designee Panel</h2>
        <div>
            <p>This panel is used to create a new designee access account for individuals who need access to the DELTA System who are not existing Polk County Public Schools school counselors or school administrators. In order to minimize duplication of user accounts, it is required that you first attempt to search our user database for an account for the user you are assigning designee access rights for. Once you search, you will have the option to use one of the search results or create a new user account for the designee access.</p>
            <button mat-raised-button color="primary" (click)="ShowUserSearch()">Search For User</button><br />
            <div class="margintop" *ngIf="ShowingNewUserForm && !FromSearch">
                <p>Use the form below to provide the required information to generate an account. The username for the account is automatically assigned by the district user account system. A randomly generated secure default password will be assigned to all new accounts created.</p>
                <p><strong>Note: </strong>The user whose account is being created <u>will</u> be emailed the account information along with instructions on how to use the district Password Reset Tool to change their default password.</p>
            </div>
        </div>
        <form [hidden]="!ShowingNewUserForm" [formGroup]="NewUserForm" novalidate class="margintop">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap.gt-sm="25px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start stretch">
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                    <form-label>First Name: </form-label>
                    <mat-form-field fxFlex.lt-md>
                        <input type="text" matInput formControlName="FirstName" placeholder="First Name..." maxlength="50" />
                        <mat-error *ngIf="NewUserForm.controls['FirstName'].hasError('required')">User first name required</mat-error>
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                    <form-label>Last Name: </form-label>
                    <mat-form-field fxFlex.lt-md>
                        <input type="text" matInput formControlName="LastName" placeholder="Last Name..." maxlength="50" />
                        <mat-error *ngIf="NewUserForm.controls['LastName'].hasError('required')">User last name required</mat-error>
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                    <form-label>Email: </form-label>
                    <mat-form-field fxFlex.lt-md>
                        <input type="text" matInput formControlName="Email" placeholder="Email Address..." maxlength="100" />
                        <mat-error *ngIf="NewUserForm.controls['Email'].hasError('required')">User email address required</mat-error>
                        <mat-error *ngIf="NewUserForm.controls['Email'].hasError('validateEmail')">Invalid email address format</mat-error>
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                    <form-label>Email Verification: </form-label>
                    <mat-form-field fxFlex.lt-md>
                        <input type="text" matInput formControlName="EmailVerify" placeholder="Email Address Verification..." maxlength="100" [errorStateMatcher]="parentErrorStateMatcher" />
                        <mat-error *ngIf="NewUserForm.controls['EmailVerify'].hasError('required')">User email address required</mat-error>
                        <mat-error *ngIf="NewUserForm.controls['EmailVerify'].hasError('validateEmail')">Invalid email address format</mat-error>
                        <mat-error *ngIf="NewUserForm.hasError('EmailVerifyValidate') && !NewUserForm.controls['EmailVerify'].errors">Verification email does not match original email</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap.gt-sm="25px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start stretch">
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                    <form-label>School: </form-label>
                    <mat-form-field fxFlex.lt-md floatLabel="never" class="wideselect">
                        <mat-select formControlName="School" placeholder="Select School..." aria-label="School Selection List">
                            <mat-option>Select School...</mat-option>
                            <mat-option *ngFor="let sch of AvailableSchools" [value]="sch">{{sch.SchoolName}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="NewUserForm.controls['School'].hasError('required')">School required</mat-error>
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                    <form-label>Role: </form-label>
                    <mat-form-field fxFlex.lt-md floatLabel="never" class="wideselect">
                        <mat-select formControlName="Role" placeholder="Select Role..." aria-label="Role Selection List">
                            <mat-option>Select Role...</mat-option>
                            <mat-option *ngFor="let rol of AvailableRoles" [value]="rol">{{rol.RoleName}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="NewUserForm.controls['Role'].hasError('required')">Role required</mat-error>
                    </mat-form-field>
                </div>
                <div *ngIf="NewUserRole.value != null && NewUserRole.value.CanBypass" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start stretch">
                    <mat-checkbox formControlName="CanBypassAdmin"><form-label>Can Bypass Administrator</form-label></mat-checkbox>
                </div>
            </div>
        </form>
        <div *ngIf="ShowingNewUserForm" class="actionbar" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start center">
            <button type="text" mat-raised-button color="primary" (click)="AddNewDesignee()" [disabled]="NewUserForm.invalid">Add User As Designee</button>
            <button type="text" mat-raised-button color="warn" (click)="ResetNewUserForm()">Cancel</button>
        </div>
    </div>

    <!-- Designees Table -->
    <mat-table class="bordered" #table [dataSource]="DesigneesData" matSort matSortActive="LastName" matSortDirection="asc">
        <ng-container matColumnDef="LastName">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered"><span>Last Name</span></mat-header-cell>
            <mat-cell *matCellDef="let designee" class="centered"><span>{{designee.LastName | titleCase}}</span></mat-cell>
        </ng-container>

        <ng-container matColumnDef="FirstName">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">First Name</mat-header-cell>
            <mat-cell *matCellDef="let designee" class="centered">{{designee.FirstName | titleCase}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="SchoolName">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">School</mat-header-cell>
            <mat-cell *matCellDef="let designee" class="centered">{{designee.SchoolName}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="RoleName">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Role</mat-header-cell>
            <mat-cell *matCellDef="let designee" class="centered">{{designee.RoleName}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="CanBypassAdmin">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Bypass Admin?</mat-header-cell>
            <mat-cell *matCellDef="let designee" class="centered">{{designee.CanBypassAdmin | yesNo}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="DesigneeActions">
            <mat-header-cell *matHeaderCellDef class="centered">Action(s)</mat-header-cell>
            <mat-cell *matCellDef="let designee" class="centered">
                <button mat-raised-button color="primary" (click)="RemoveDesignee(designee)">
                    <span>Remove<span fxHide fxShow.gt-md> As Designee</span></span>
                </button>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="SmallDisplay">
            <mat-header-cell *matHeaderCellDef class="centered">Designee(s)</mat-header-cell>
            <mat-cell *matCellDef="let designee">
                <div fxLayout="column" fxLayoutAlign="start stretch">
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div>Last Name</div>
                        <div>{{designee.LastName | titleCase}}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div>First Name</div>
                        <div>{{designee.FirstName | titleCase}}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div>School</div>
                        <div>{{designee.SchoolName}}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div>Role</div>
                        <div>{{designee.RoleName}}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div>Bypass Admin?</div>
                        <div>{{designee.CanBypassAdmin | yesNo}}</div>
                    </div>
                    <div class="smalldisplaybuttongroup" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px">
                        <button mat-raised-button color="primary" (click)="RemoveDesignee(designee)">Remove As Designee</button>
                    </div>
                </div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="NoData">
            <mat-header-cell *matHeaderCellDef>&nbsp;</mat-header-cell>
            <mat-cell *matCellDef="let designee"><em>No designees have been set for the system.</em></mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="VisibleHeaders"></mat-header-row>
        <mat-row *matRowDef="let row;columns: VisibleColumns;let $even = even" [class.primarybackground50]="$even"></mat-row>
    </mat-table>
    <mat-paginator #paginator [length]="DesigneesData.data.length" [pageIndex]="0" [pageSize]="(SmallDisplay ? 5 : 10)" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
</div>


// WEBPACK FOOTER //
// ./src/app/managedesignees/managedesignees.component.html